<form
	[formGroup]="formGroup"
	[ngClass]="{'mt-5': addSpaceToPrevious}"
>
	<div
		class="row mb-3 formElementWrapper"
		[ngClass]="baseCssClass"
		(mouseover)="setHovered( true )"
		(mouseout)="setHovered( false )"
	>

		<!-- Label -->
		<ng-container *ngIf="!config.hideLabel">
			<app-label
				formEntityId="{{ formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId }}"
				labelText="{{ labelText ? labelText : getI18nString(false, translationPath + '.label') }}"
				[formControlInline]="formControlInline"
				[labelClassObject]="{
					'hovered': isHovered,
					'focused': hasFocus,
					'error': control?.errors && !hideErrors
				}"
				[labelHostClassString]="labelHostClassString"
				[labelInfoInline]="labelInfoInline"
				[required]="isRequired"
				[requiredByElster]="config.elsterRequiredField"
				[showElsterIndicator]="config.elsterShowIndicator"
			></app-label>
		</ng-container>

		<!-- Input Block -->
		<div
			class="inputBlockWrapper col-12"
			[ngClass]="{'col-md-8' : formControlInline}"
		>

			<div class="col-{{colSpan}} px-0">
				<!-- Input Wrapper -->
				<div
					class="inputWrapper mb-1"
					[ngClass]="{
						'controlDisabled': disableControl,
						'hovered': isHovered,
						'focused': hasFocus,
						'error': control?.errors && !hideErrors
					}"
					(focusin)="onInputWrapperFocus()"
				>

					<!-- Input Group -->
					<div class="row gx-0 px-2 flex-nowrap">
						<!-- Select -->
						<ng-select
							#ngSelect
							class="col"
							id="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
							formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
							labelForId="{{formEntityId}}"
							tabindex="'{{config.tabindex}}'"
							[appDisableControl]="{condition: disableControl, control: control}"
							[attr.data-e2e]="formEntityId + '-select'"
							[bindLabel]="bindLabel"
							[bindValue]="bindValue"
							[groupBy]="groupBy"
							[items]="itemList"
							[loading]="isLoading"
							[multiple]="multiple"
							[placeholder]="config.hidePlaceholder ? null : getI18nString(false,translationPath + '.placeholder')"
							[readonly]="disableControl || readOnly"
							[searchable]="searchable"
							[virtualScroll]="virtualScroll"
							(change)="onChange($event)"
							(focusin)="setFocus( true )"
							(focusout)="setFocus( false )"
							(remove)="onRemoveItem($event)"
							(search)="onSearchChange($event.term)"
						>

							<!-- Selected Item -->
							<ng-template ng-label-tmp let-item="item" let-clear="clear">
								<ng-container
									[ngTemplateOutlet]="projectSelectedItemTemplateRef ? projectSelectedItemTemplateRef : optionItemTpl"
									[ngTemplateOutletContext]="{
										clear: clear,
										item: item,
										label: bindLabel,
										type:'selectedItem',
										value: bindValue
									 }"
								></ng-container>
							</ng-template>

							<!-- Options Item -->
							<ng-template ng-option-tmp let-item="item">
								<ng-container
									[ngTemplateOutlet]="projectOptionsItemTemplateRef ? projectOptionsItemTemplateRef : optionItemTpl"
									[ngTemplateOutletContext]="{
										item: item,
										label: bindLabel,
										type:'listItem',
										value: bindValue
									}"
								></ng-container>
							</ng-template>

							<!-- Option Group Label -->
							<ng-template ng-option-tmp ng-optgroup-tmp let-item="item">
								<ng-container
									[ngTemplateOutlet]="projectOptionsGroupItemTemplateRef ? projectOptionsGroupItemTemplateRef : optionItemTpl"
									[ngTemplateOutletContext]="{
										item: item,
										label: groupBy,
										type:'groupItem',
										value: bindValue
									}"
								></ng-container>
							</ng-template>
						</ng-select>

						<!-- Actions -->
						<div class="d-flex col-auto input-actions">

							<div *ngIf="showClearButton && !disableControl">
								<i class="input-group-text ft-x" (click)="clearControlValue()"></i>
							</div>

							<div *ngIf="showRevertButton">
								<i class="input-group-text icon-action-undo" (click)="revertControlValue()"></i>
							</div>
						</div>
					</div>
				</div>

				<!-- Error -->
				<app-error
					[control]="control"
					[hideErrors]="hideErrors || hideErrorDescriptions"
					[errorMsg]="errorMsg"
				></app-error>
			</div>

			<!-- Input Information -->
			<app-info
				[baseClass]="'col-12 mb-3 mt-2 px-0'"
				[hideInfoIcon]="true"
				[infoText]="getI18nString( false, translationPath + '.info' )"
			></app-info>
		</div>

	</div>
</form>

<!-- ######################### TEMPLATES ######################### -->
<!-- Option Item -->
<ng-template
	#optionItemTpl
	let-item="item"
	let-value="value"
	let-label="label"
	let-type="type"
	let-clear="clear"
>
	<div
		*ngIf="item"
		(mouseenter)="changeTooltipVisibility(tooltip, type ==='listItem', item?.tooltipDataList)"
		(mouseleave)="changeTooltipVisibility(tooltip, false)"
		(click)="tooltip?.close(); tooltip.container = null"
	>

		<span
			*ngIf="type ==='selectedItem'"
			class="ng-value-icon left"
			aria-hidden="true"
			(click)="clear(item)"
		>×</span>

		<span
			#tooltip="ngbTooltip"
			[ngClass]="{
				'ng-option-label': isSelectedItem( item[ value ] ),
				'pe-1': multiple && type ==='selectedItem',
				'px-1 disabled': multiple && type ==='selectedItem' && item.disabled
			}"
			[ngbTooltip]="optionTooltipTpl"
			[container]="'body'"
			[disableTooltip]="!item?.tooltipDataList"
			[triggers]="null"
		>
			{{ item[ label ] }}
		</span>
	</div>
</ng-template>

<!-- Option Tooltip -->
<ng-template
	#optionTooltipTpl
	let-tooltipDataList="tooltipDataList"
>
	<ng-container *ngFor="let tooltipItem of tooltipDataList">
			<span class="{{ tooltipItem?.styleClass }}" [innerHTML]="tooltipItem?.value"></span>
	</ng-container>
</ng-template>
